import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

// Actions
import { setCurrency } from "redux/auth/slice";

// Types
import { GeoByIpResponseType } from "types/Geo";

// Utils
import { setHostname } from "utils/hostname";

// URL
import url from "url/index";
import { setServiceError } from "stores/settings";
import { setHeaders } from "utils/credential";
import { setCountry } from "./slice";

export const geoApi = createApi({
  reducerPath: "geoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: setHostname(),
    prepareHeaders: setHeaders,
  }),
  endpoints: (build) => ({
    geoByIp: build.query<GeoByIpResponseType, string>({
      query: () => ({
        url: url.config.api.geo.geoByIp,
      }),
      async onQueryStarted(request: string, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.statusCode === 200 && data.data) {
            const country = data.data.name;
            dispatch(setCurrency(data.data.currencyIsoCode));
            dispatch(setCountry(country));
          }
          if (data.statusCode >= 500) {
            setServiceError(true);
          }
        } catch (error: any) {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      },
    }),
  }),
});
